import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InvoicePaymentModalContent from "./InvoicePaymentModalContent";
import { InvoicePaymentModalFormProvider } from "contexts/invoicePage/InvoicePaymentModalFormContext";
var providers = [
    function(children) {
        return /*#__PURE__*/ _jsx(InvoicePaymentModalFormProvider, {
            children: children
        });
    }
];
var ComponentProvider = function(param) {
    var children = param.children;
    return providers.reduceRight(function(acc, ProviderFn) {
        return ProviderFn(acc);
    }, children);
};
export default function InvoicePaymentModal() {
    return /*#__PURE__*/ _jsx(ComponentProvider, {
        children: /*#__PURE__*/ _jsx(InvoicePaymentModalContent, {})
    });
}
